module.exports = [
 {
  "start": 291,
  "end": 1500,
  "text": "Deine Raumkapsel Capsule "
 },
 {
  "start": 1583,
  "end": 3583,
  "text": "is a bedroom in a transport crate "
 },
 {
  "start": 3667,
  "end": 5500,
  "text": "I developed after a breakdown "
 },
 {
  "start": 5583,
  "end": 7333,
  "text": "from too much work installing, "
 },
 {
  "start": 7417,
  "end": 9417,
  "text": "cabling and so on…"
 },
 {
  "start": 9542,
  "end": 12250,
  "text": "so I conceived it as a plug and play work."
 },
 {
  "start": 12458,
  "end": 14625,
  "text": "In our dreams and meditation "
 },
 {
  "start": 14708,
  "end": 16542,
  "text": "we can get a little sense "
 },
 {
  "start": 16625,
  "end": 19959,
  "text": "in how tiny and transient our wonderful "
 },
 {
  "start": 20041,
  "end": 23375,
  "text": "and incomprehensible existence is."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room8/audio4/08_4MCA Deine Raumkapsel.js